/* eslint-disable */
const mutations = {
  setCancelOrderReasons(state, { cancelOrderReasons }) {
    state.data = cancelOrderReasons;
  },
};

export default mutations;
